/**
 * Normalise a raw phone string to a 10-digit Indian mobile number.
 * Strips spaces, hyphens, dots, parentheses, plus signs.
 * Removes the leading +91 / 91 (12-digit) / 0 (11-digit) prefix.
 */
export function normalizePhone(v) {
  if (!v) return '';
  let s = String(v).replace(/[\s\-()+.]/g, '');
  if (s.startsWith('91') && s.length === 12) s = s.slice(2);
  else if (s.startsWith('0') && s.length === 11) s = s.slice(1);
  return s;
}

/** Returns true if `v` is a valid 10-digit Indian mobile number (after normalisation). */
export function isValidPhone(v) {
  return /^[6-9]\d{9}$/.test(normalizePhone(v));
}

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
